export default "__VITE_ASSET__CSDlcZbj__"